
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ActivateUserResponse": [
      "ActivateUserSuccessfulResponse",
      "ErrorResponse"
    ],
    "AssessmentResultData": [
      "CardioRespResult",
      "InbodyCompositionResult",
      "IndividualMotivationResult",
      "ML360Result",
      "PersonalCopingResult",
      "ProcessingSpeedResult",
      "SartResult",
      "SelfDeterminationResult",
      "SpatialPlanningResult",
      "StrengthResult",
      "TeamResilienceResult",
      "TrainersNotesResult",
      "VisualReactionResult"
    ],
    "AssistantMessage": [
      "AssistantAgentMessage",
      "AssistantBarChartMessage",
      "AssistantSystemMessage",
      "AssistantTabbedComparisonChartMessage",
      "AssistantUserMessage"
    ],
    "BaseContentItem": [
      "AudioContentItem",
      "PdfContentItem",
      "VideoContentItem"
    ],
    "BaseContentItemProgress": [
      "AudioContentProgress",
      "PdfContentProgress",
      "VideoContentProgress"
    ],
    "BaseContentModuleConfiguration": [
      "NutritionAudioConfiguration",
      "NutritionPdfConfiguration",
      "NutritionVideoConfiguration",
      "TrainingAudioConfiguration",
      "TrainingPdfConfiguration",
      "TrainingVideoConfiguration"
    ],
    "BaseCourse": [
      "CourseInstance",
      "CourseTemplate"
    ],
    "BaseModuleDefinition": [
      "AssessmentModuleDefinition",
      "ExternalModuleDefinition",
      "ReportingModuleDefinition",
      "TrainingModuleDefinition"
    ],
    "BaseModuleInstanceConfiguration": [
      "BmpConfiguration",
      "CardioRespConfiguration",
      "FinSwimConfiguration",
      "InbodyCompositionConfiguration",
      "IndividualMotivationModuleInstanceConfiguration",
      "IpptConfiguration",
      "ML360ModuleInstanceConfiguration",
      "March20KmConfiguration",
      "PersonalCopingModuleInstanceConfiguration",
      "ProcessingSpeedModuleInstanceConfiguration",
      "SARTModuleInstanceConfiguration",
      "SelfDeterminationModuleInstanceConfiguration",
      "SocConfiguration",
      "SpatialPlanningModuleInstanceConfiguration",
      "StrengthConfiguration",
      "TeamResilienceModuleInstanceConfiguration",
      "VisualReactionModuleInstanceConfiguration",
      "WeightConfiguration"
    ],
    "BaseUser": [
      "SuperAdminUser",
      "TenantUser"
    ],
    "BasicAuthenticationResponse": [
      "BasicAuthenticationRequire2FASetupResponse",
      "BasicAuthenticationRequireOtpResponse",
      "BasicAuthenticationResetPasswordResponse",
      "BasicAuthenticationSuccessfulResponse",
      "ErrorResponse"
    ],
    "Broadcast": [
      "UserSessionBroadcast"
    ],
    "CancelInvitationPayload": [
      "CancelInvitationSuccessfulResponse",
      "ErrorResponse"
    ],
    "ChangeEmailResponse": [
      "ChangeEmailSuccessfulResponse",
      "ErrorResponse"
    ],
    "ChangePasswordResponse": [
      "ChangePasswordSuccessfulResponse",
      "ErrorResponse"
    ],
    "ChangeRoleResponse": [
      "CurrentUser",
      "ErrorResponse"
    ],
    "ConfirmEmailResponse": [
      "ConfirmEmailSuccessfulResponse",
      "ErrorResponse"
    ],
    "ContentItemProgress": [
      "AudioContentProgress",
      "PdfContentProgress",
      "VideoContentProgress"
    ],
    "Course": [
      "CourseInstance",
      "CourseTemplate"
    ],
    "CreateAssessmentRunsPayload": [
      "CreateAssessmentRunsSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateCompanyPayload": [
      "CreateCompanySuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateCourseInstancePayload": [
      "CreateCourseInstanceSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateCourseTemplatePayload": [
      "CreateCourseTemplateSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateGlossaryPayload": [
      "CreateGlossarySuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateGroupPayload": [
      "CreateGroupSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateModuleInstancePayload": [
      "CreateModuleInstanceSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateProgramPayload": [
      "CreateProgramSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateSubgroupPayload": [
      "CreateSubgroupSuccessfulResponse",
      "ErrorResponse"
    ],
    "CreateUserResponse": [
      "CreateUserSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeactivateUserResponse": [
      "DeactivateUserSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteAssessmentResultPayload": [
      "DeleteAssessmentResultSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteAssessmentRunsPayload": [
      "DeleteAssessmentRunsSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteCompanyPayload": [
      "DeleteCompanySuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteCourseInstancePayload": [
      "DeleteCourseInstanceSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteCourseTemplatePayload": [
      "DeleteCourseTemplateSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteCourseTemplateSeriesPayload": [
      "DeleteCourseTemplateSeriesSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteGlossaryPayload": [
      "DeleteGlossarySuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteGroupPayload": [
      "DeleteGroupSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteModuleInstancePayload": [
      "DeleteModuleInstanceSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeletePerformanceResultPayload": [
      "DeletePerformanceResultSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteProgramPayload": [
      "DeleteProgramSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteSubgroupPayload": [
      "DeleteSubgroupSuccessfulResponse",
      "ErrorResponse"
    ],
    "DeleteUserResponse": [
      "DeleteUserSuccessfulResponse",
      "ErrorResponse"
    ],
    "DownloadTemplateImportUsersPayload": [
      "DownloadTemplateImportUsersResponse",
      "ErrorResponse"
    ],
    "EnableAuthenticatorResponse": [
      "EnableAuthenticatorSuccessfulResponse",
      "ErrorResponse"
    ],
    "ExportAssessmentResultPayload": [
      "ErrorResponse",
      "ExportAssessmentResultSuccessfulResponse"
    ],
    "ExportPerformanceResultPayload": [
      "ErrorResponse",
      "ExportPerformanceResultSuccessfulResponse"
    ],
    "ExportUsersPayload": [
      "ErrorResponse",
      "ExportUsersSuccessfulResponse"
    ],
    "GenerateTrainersNotesPayload": [
      "ErrorResponse",
      "GenerateTrainersNotesQueuedResponse"
    ],
    "ImportAssessmentResultPayload": [
      "ErrorResponse",
      "ImportAssessmentResultSuccessfulResponse"
    ],
    "ImportPerformanceResultPayload": [
      "ErrorResponse",
      "ImportPerformanceResultSuccessfulResponse"
    ],
    "ImportUsersPayload": [
      "ErrorResponse",
      "ImportUsersSuccessfulResponse"
    ],
    "ImportUsersProgressPayload": [
      "ErrorResponse",
      "ImportUsersProgressSuccessfulResponse"
    ],
    "InviteResponse": [
      "ErrorResponse",
      "InviteSuccessfulResponse"
    ],
    "InviteeResponse": [
      "ErrorResponse",
      "InviteeSuccessResponse"
    ],
    "ModuleDefinition": [
      "AssessmentModuleDefinition",
      "ExternalModuleDefinition",
      "ReportingModuleDefinition",
      "TrainingModuleDefinition"
    ],
    "ModuleInstanceConfiguration": [
      "BmpConfiguration",
      "CardioRespConfiguration",
      "FinSwimConfiguration",
      "InbodyCompositionConfiguration",
      "IndividualMotivationModuleInstanceConfiguration",
      "IpptConfiguration",
      "ML360ModuleInstanceConfiguration",
      "March20KmConfiguration",
      "NutritionAudioConfiguration",
      "NutritionPdfConfiguration",
      "NutritionVideoConfiguration",
      "PersonalCopingModuleInstanceConfiguration",
      "ProcessingSpeedModuleInstanceConfiguration",
      "SARTModuleInstanceConfiguration",
      "SelfDeterminationModuleInstanceConfiguration",
      "SocConfiguration",
      "SpatialPlanningModuleInstanceConfiguration",
      "StrengthConfiguration",
      "TeamResilienceModuleInstanceConfiguration",
      "TrainingAudioConfiguration",
      "TrainingPdfConfiguration",
      "TrainingVideoConfiguration",
      "VisualReactionModuleInstanceConfiguration",
      "WeightConfiguration"
    ],
    "PerformanceResultData": [
      "BmpResult",
      "FinSwimResult",
      "IpptResult",
      "March20kmResult",
      "SocResult",
      "WeightResult"
    ],
    "PhysicalBaseConfiguration": [
      "BmpConfiguration",
      "CardioRespConfiguration",
      "FinSwimConfiguration",
      "InbodyCompositionConfiguration",
      "IpptConfiguration",
      "March20KmConfiguration",
      "SocConfiguration",
      "StrengthConfiguration",
      "WeightConfiguration"
    ],
    "RequestNewPasswordResponse": [
      "ErrorResponse",
      "RequestNewPasswordSuccessfulResponse"
    ],
    "ResetPasswordResponse": [
      "ErrorResponse",
      "ResetPasswordSuccessfulResponse"
    ],
    "ResponseResult": [
      "LikertScaleResult",
      "RatingScaleResult"
    ],
    "ResponseType": [
      "LikertScaleResponse",
      "RatingScaleResponse"
    ],
    "SSOConfiguration": [
      "MSALConfiguration",
      "OIDCConfiguration"
    ],
    "SignUpResponse": [
      "ErrorResponse",
      "SignUpSuccessResponse"
    ],
    "SpotifyAudioMetadataPayload": [
      "ErrorResponse",
      "SpotifyAudioMetadataSuccessfulResponse"
    ],
    "SubmitAudioTrainingResultPayload": [
      "ErrorResponse",
      "SubmitAudioTrainingResultSuccessfulResponse"
    ],
    "SubmitBmpResultPayload": [
      "ErrorResponse",
      "SubmitBmpResultSuccessfulResponse"
    ],
    "SubmitCardioRespResultPayload": [
      "ErrorResponse",
      "SubmitCardioRespResultSuccessfulResponse"
    ],
    "SubmitFinSwimResultPayload": [
      "ErrorResponse",
      "SubmitFinSwimResultSuccessfulResponse"
    ],
    "SubmitInbodyCompositionResultPayload": [
      "ErrorResponse",
      "SubmitInbodyCompositionResultSuccessfulResponse"
    ],
    "SubmitIndividualMotivationAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitIndividualMotivationAssessmentResultSuccessfulResponse"
    ],
    "SubmitIpptResultPayload": [
      "ErrorResponse",
      "SubmitIpptResultSuccessfulResponse"
    ],
    "SubmitML360AssessmentResultPayload": [
      "ErrorResponse",
      "SubmitML360AssessmentResultSuccessfulResponse"
    ],
    "SubmitMarch20KmResultPayload": [
      "ErrorResponse",
      "SubmitMarch20KmResultSuccessfulResponse"
    ],
    "SubmitPdfTrainingResultPayload": [
      "ErrorResponse",
      "SubmitPdfTrainingResultSuccessfulResponse"
    ],
    "SubmitPersonalCopingAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitPersonalCopingAssessmentResultSuccessfulResponse"
    ],
    "SubmitProcessingSpeedAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitProcessingSpeedAssessmentResultSuccessfulResponse"
    ],
    "SubmitSartAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitSartAssessmentResultSuccessfulResponse"
    ],
    "SubmitSelfDeterminationAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitSelfDeterminationAssessmentResultSuccessfulResponse"
    ],
    "SubmitSocResultPayload": [
      "ErrorResponse",
      "SubmitSocResultSuccessfulResponse"
    ],
    "SubmitSpatialPlanningAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitSpatialPlanningAssessmentResultSuccessfulResponse"
    ],
    "SubmitStrengthResultPayload": [
      "ErrorResponse",
      "SubmitStrengthResultSuccessfulResponse"
    ],
    "SubmitTeamResilienceAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitTeamResilienceAssessmentResultSuccessfulResponse"
    ],
    "SubmitTrainersNotesResultPayload": [
      "ErrorResponse",
      "SubmitTrainersNotesResultSuccessfulResponse"
    ],
    "SubmitVideoTrainingResultPayload": [
      "ErrorResponse",
      "SubmitVideoTrainingResultSuccessfulResponse"
    ],
    "SubmitVisualReactionAssessmentResultPayload": [
      "ErrorResponse",
      "SubmitVisualReactionAssessmentResultSuccessfulResponse"
    ],
    "SubmitWeightResultPayload": [
      "ErrorResponse",
      "SubmitWeightResultSuccessfulResponse"
    ],
    "SwitchCompanyResponse": [
      "ErrorResponse",
      "SwitchCompanySuccessfulResponse"
    ],
    "TemplateDownloadPayload": [
      "ErrorResponse",
      "TemplateDownloadSuccessfulResponse"
    ],
    "UpdateAssessmentRunsPayload": [
      "ErrorResponse",
      "UpdateAssessmentRunsSuccessfulResponse"
    ],
    "UpdateAudioTrainingProgressPayload": [
      "ErrorResponse",
      "UpdateAudioTrainingProgressSuccessfulResponse"
    ],
    "UpdateBmpResultPayload": [
      "ErrorResponse",
      "UpdateBmpResultSuccessfulResponse"
    ],
    "UpdateCardioRespResultPayload": [
      "ErrorResponse",
      "UpdateCardioRespResultSuccessfulResponse"
    ],
    "UpdateCompanyPayload": [
      "ErrorResponse",
      "UpdateCompanySuccessfulResponse"
    ],
    "UpdateCourseInstancePayload": [
      "ErrorResponse",
      "UpdateCourseInstanceSuccessfulResponse"
    ],
    "UpdateCourseTemplatePayload": [
      "ErrorResponse",
      "UpdateCourseTemplateSuccessfulResponse"
    ],
    "UpdateFinSwimResultPayload": [
      "ErrorResponse",
      "UpdateFinSwimResultSuccessfulResponse"
    ],
    "UpdateGlossaryPayload": [
      "ErrorResponse",
      "UpdateGlossarySuccessfulResponse"
    ],
    "UpdateGroupPayload": [
      "ErrorResponse",
      "UpdateGroupSuccessfulResponse"
    ],
    "UpdateInbodyCompositionResultPayload": [
      "ErrorResponse",
      "UpdateInbodyCompositionResultSuccessfulResponse"
    ],
    "UpdateIpptResultPayload": [
      "ErrorResponse",
      "UpdateIpptResultSuccessfulResponse"
    ],
    "UpdateMarch20KmResultPayload": [
      "ErrorResponse",
      "UpdateMarch20KmResultSuccessfulResponse"
    ],
    "UpdateModuleInstancePayload": [
      "ErrorResponse",
      "UpdateModuleInstanceSuccessfulResponse"
    ],
    "UpdatePdfTrainingProgressPayload": [
      "ErrorResponse",
      "UpdatePdfTrainingProgressSuccessfulResponse"
    ],
    "UpdateProfileResponse": [
      "ErrorResponse",
      "UpdateProfileSuccessfulResponse"
    ],
    "UpdateProgramPayload": [
      "ErrorResponse",
      "UpdateProgramSuccessfulResponse"
    ],
    "UpdateSSOResponse": [
      "ErrorResponse",
      "UpdateSSOSuccessfulResponse"
    ],
    "UpdateSocResultPayload": [
      "ErrorResponse",
      "UpdateSocResultSuccessfulResponse"
    ],
    "UpdateStrengthResultPayload": [
      "ErrorResponse",
      "UpdateStrengthResultSuccessfulResponse"
    ],
    "UpdateSubgroupPayload": [
      "ErrorResponse",
      "UpdateSubgroupSuccessfulResponse"
    ],
    "UpdateTrainersNotesResultPayload": [
      "ErrorResponse",
      "UpdateTrainersNotesResultSuccessfulResponse"
    ],
    "UpdateUserConsentResponse": [
      "ErrorResponse",
      "UpdateUserConsentSuccessfulResponse"
    ],
    "UpdateUserPayload": [
      "ErrorResponse",
      "UpdateUserSuccessfulResponse"
    ],
    "UpdateVideoTrainingProgressPayload": [
      "ErrorResponse",
      "UpdateVideoTrainingProgressSuccessfulResponse"
    ],
    "UpdateWeightResultPayload": [
      "ErrorResponse",
      "UpdateWeightResultSuccessfulResponse"
    ],
    "UploadFilePayload": [
      "ErrorResponse",
      "UploadFileSuccessfulResponse"
    ],
    "UploadPdfContentItemPayload": [
      "ErrorResponse",
      "UploadPdfContentItemSuccessfulResponse"
    ],
    "User": [
      "SuperAdminUser",
      "TenantUser"
    ],
    "ValidateImportAssessmentResultPayload": [
      "ErrorResponse",
      "ValidateImportAssessmentResultSuccessfulResponse"
    ],
    "ValidateImportPerformanceResultPayload": [
      "ErrorResponse",
      "ValidateImportPerformanceResultSuccessfulResponse"
    ],
    "ValidateImportUsersPayload": [
      "ErrorResponse",
      "ValidateImportUsersSuccessfulResponse"
    ],
    "VariantSpecifics": [
      "AssessmentModuleDefinition",
      "TrainingModuleDefinition"
    ],
    "VerifyOtpResponse": [
      "ErrorResponse",
      "VerifyOtpSuccessfulResponse"
    ],
    "YouTubeVideoMetadataPayload": [
      "ErrorResponse",
      "YouTubeVideoMetadataSuccessfulResponse"
    ]
  }
};
      export default result;
    